import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
var BitmapFontData = /*#__PURE__*/_createClass(function BitmapFontData() {
  _classCallCheck(this, BitmapFontData);
  this.info = [];
  this.common = [];
  this.page = [];
  this.char = [];
  this.kerning = [];
  this.distanceField = [];
});
export { BitmapFontData };